const FEATURE_ITEMS = [
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '7×24小时不间断监控全网信源，黑料吃瓜爆料不停，确保你第一时间获取最新娱乐八卦动态，永远快人一步。',
  },
  {
    icon: 'ri-stack-line',
    title: '全面覆盖',
    desc: '从明星私生活到综艺黑幕，从网红翻车到行业政策，91黑料吃瓜在线覆盖吃瓜黑料网所有热门领域。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '理性吃瓜',
    desc: '标注信息来源可信度，多方交叉验证，引导健康围观文化。91黑料吃瓜网倡导有态度的吃瓜方式。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '随时随地',
    desc: '响应式设计完美适配桌面与移动端，无论在哪里都能随时围观最新黑料事件，吃瓜体验不打折。',
  },
];

export default function Features() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-900">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            <i className="ri-star-line text-primary-400 mr-2"></i>
            平台特色
          </h2>
          <p className="mt-2 text-sm text-foreground-500">为什么数百万瓜友选择91黑料吃瓜网</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {FEATURE_ITEMS.map((item, i) => (
            <div
              key={i}
              className="p-5 md:p-6 rounded-xl bg-background-800/30 border border-background-800/50 hover:border-primary-500/20 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/10 text-primary-400 mb-5 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-200 mb-2.5">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}